/**
 * Generated bundle index. Do not edit.
 */

export * from './public_api';

export {NbIsGrantedDirective as ɵa} from './directives/is-granted.directive';